// extracted by mini-css-extract-plugin
export var modal = "_v9-0";
export var table = "_v9-1";